"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _HiddenMeasure = _interopRequireDefault(require("../layout/utils/HiddenMeasure"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _Overflows = require("../utils/Overflows");

var _Timers = require("../utils/Timers");

var UITruncateString =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITruncateString, _PureComponent);

  function UITruncateString(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UITruncateString);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITruncateString).call(this, props));

    _this.updateTruncatedState = function () {
      var _this$props = _this.props,
          matchContentWidth = _this$props.matchContentWidth,
          reverse = _this$props.reverse;
      var contentWidth;

      if (matchContentWidth) {
        contentWidth = _this._measureEl.clientWidth + 1;
      }

      var isTruncated;
      var wrapperEl = _this._wrapperEl;

      if (reverse) {
        var tailEl = _this._tailEl;
        isTruncated = (0, _Overflows.overflowsX)(tailEl, wrapperEl);
      } else {
        isTruncated = (0, _Overflows.overflowsX)(wrapperEl);
      }

      if (contentWidth !== _this.state.contentWidth || isTruncated !== _this.state.isTruncated) {
        _this.setState({
          contentWidth: contentWidth,
          isTruncated: isTruncated
        });
      }
    };

    _this.delayedUpdateTruncatedState = function () {
      (0, _Timers.cancelSchedulerCallback)(_this._timeout); // Ensure only one callback is queued at a time

      _this._timeout = (0, _Timers.requestSchedulerCallback)(_this.updateTruncatedState);
    };

    _this.state = {
      contentWidth: undefined,
      isTruncated: null
    };
    _this._key = 0;
    return _this;
  }

  (0, _createClass2.default)(UITruncateString, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.ResizeObserver) {
        this._resizeObserver = new ResizeObserver(this.delayedUpdateTruncatedState);

        this._resizeObserver.observe(this._wrapperEl);
      } else {
        this.updateTruncatedState();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // Workaround for a truly bizarre Safari bug (#5825)
      var hasMaxWidth = this.props.maxWidth != null;
      var willHaveMaxWidth = nextProps.maxWidth != null;

      if (hasMaxWidth !== willHaveMaxWidth) {
        this._key = this._key + 1;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Fallback for IE11, which doesn't support ResizeObserver
      if (!this._resizeObserver) {
        // ⚠️ This condition prevents infinite loops! ⚠️
        if (prevState.contentWidth === this.state.contentWidth && prevState.isTruncated === this.state.isTruncated) {
          this.delayedUpdateTruncatedState();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _Timers.cancelSchedulerCallback)(this._timeout);
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          fixedChildren = _this$props2.fixedChildren,
          innerClassName = _this$props2.innerClassName,
          matchContentWidth = _this$props2.matchContentWidth,
          maxWidth = _this$props2.maxWidth,
          placement = _this$props2.placement,
          reverse = _this$props2.reverse,
          tooltip = _this$props2.tooltip,
          useFlex = _this$props2.useFlex,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "className", "fixedChildren", "innerClassName", "matchContentWidth", "maxWidth", "placement", "reverse", "tooltip", "useFlex"]);
      var _this$state = this.state,
          contentWidth = _this$state.contentWidth,
          isTruncated = _this$state.isTruncated;
      var computedClassName = (0, _classnames.default)('private-truncated-string', className, {
        'private-truncated-string--is-flex': useFlex,
        'private-truncated-string--has-tooltip': Boolean(isTruncated)
      }); // When maxWidth is set, we need to set maxWidth on both the outer container and the inner
      // wrapper. We also need to set width to "unset" (if we aren't using matchContentWidth) in
      // order to prevent the table column from collapsing to 0 due to the `width: 100%` rule.

      var computedMaxWidth = maxWidth && contentWidth ? Math.min(maxWidth, contentWidth) : maxWidth || contentWidth;
      var style = computedMaxWidth ? {
        maxWidth: computedMaxWidth,
        width: maxWidth ? 'unset' : undefined
      } : undefined;
      var tailClassName = (0, _classnames.default)('private-truncated-string__reverse__tail', {
        'is-truncated': isTruncated
      });
      var renderedContent = reverse ? _react.default.createElement("span", {
        className: "private-truncated-string__reverse"
      }, isTruncated ? _react.default.createElement("span", {
        className: "private-truncated-string__reverse__ellipse"
      }, "\u2026") : null, _react.default.createElement("span", {
        className: tailClassName
      }, _react.default.createElement("span", {
        className: "private-truncated-string__reverse__content",
        ref: function ref(_ref) {
          _this2._tailEl = _ref;
        }
      }, children))) : _react.default.createElement("span", null, children);
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UITooltip.default, {
        disabled: tooltip === false || isTruncated === false,
        placement: placement,
        title: typeof tooltip === 'boolean' ? children : tooltip
      }, _react.default.createElement("span", (0, _extends2.default)({}, rest, {
        className: computedClassName,
        "data-content": true,
        key: this._key,
        style: style
      }), _react.default.createElement("span", {
        className: (0, _classnames.default)('private-truncated-string__inner', innerClassName),
        ref: function ref(_ref2) {
          _this2._wrapperEl = _ref2;
        },
        style: style
      }, renderedContent), fixedChildren)), matchContentWidth && _react.default.createElement(_HiddenMeasure.default, {
        ref: function ref(_ref3) {
          _this2._measureEl = (0, _reactDom.findDOMNode)(_ref3);
        }
      }, children));
    }
  }]);
  return UITruncateString;
}(_react.PureComponent);

exports.default = UITruncateString;
UITruncateString.propTypes = {
  children: _propTypes.default.node.isRequired,
  fixedChildren: _propTypes.default.node,
  innerClassName: _propTypes.default.string,
  matchContentWidth: _propTypes.default.bool.isRequired,
  maxWidth: _propTypes.default.number,
  placement: _UITooltip.default.propTypes.placement,
  reverse: _propTypes.default.bool.isRequired,
  tooltip: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node, _propTypes.default.string]).isRequired,
  useFlex: _propTypes.default.bool.isRequired
};
UITruncateString.defaultProps = {
  placement: _UITooltip.default.defaultProps.placement,
  reverse: false,
  tooltip: true,
  matchContentWidth: false,
  useFlex: false
};
UITruncateString.displayName = 'UITruncateString';
module.exports = exports.default;